import { create } from 'zustand';

// localStorage helpers (matching Sidebar.jsx pattern)
const SIDEBAR_MINIMIZED_KEY = 'sidebar_minimized';

const loadSidebarMinimized = () => {
  try {
    const stored = localStorage.getItem(SIDEBAR_MINIMIZED_KEY);
    return stored ? JSON.parse(stored) : false;
  } catch {
    return false;
  }
};

const saveSidebarMinimized = (value) => {
  try {
    localStorage.setItem(SIDEBAR_MINIMIZED_KEY, JSON.stringify(value));
  } catch {
    // localStorage unavailable — no-op
  }
};

const useStore = create((set, get) => ({
  // User state
  user: null,
  setUser: (user) => set({ user }),

  // Tenant state
  currentTenant: 'default',
  setCurrentTenant: (tenant) => set({ currentTenant: tenant }),

  // Notification state
  notifications: [],
  addNotification: (notification) => set((state) => ({
    notifications: [...state.notifications, { id: Date.now(), ...notification }]
  })),
  clearNotifications: () => set({ notifications: [] }),

  // Dashboard refresh
  lastRefresh: null,
  setLastRefresh: () => set({ lastRefresh: new Date() }),

  // Sidebar minimize state
  sidebarMinimized: loadSidebarMinimized(),
  setSidebarMinimized: () => {
    const next = !get().sidebarMinimized;
    saveSidebarMinimized(next);
    set({ sidebarMinimized: next });
  },
}));

export default useStore;
